musicManager = {};
musicManager.idle = true;
musicManager.inFreeSpins = false;
musicManager.wasInFreeSpins = false;
musicManager.inBaseGameModifier = false;
musicManager.currentLossStreak = 0;
musicManager.currentMusicVolume = 0;

musicManager.spinButtonSounds = ['spinButton1', 'spinButton2', 'spinButton3'];

musicManager.currentBaseLevel = -1;
musicManager.ALLOFFLEVEL = [false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false];
musicManager.MORE_THAN_2X_LEVEL = [false, false, true, false];
musicManager.MORE_THAN_10X_LEVEL = [false, false, false, true];

musicManager.currentFSLevel = -1;
musicManager.FREESPINS_ALLOFF = [false, false, false];
musicManager.FREESPINS_BASE = [true, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true];

musicManager.WHEELSPIN_ALLOFF = [false];
musicManager.WHEELSPIN_BASE = [true];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.stepDownTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 0.3;
  musicManager.fadeBaseTimeOut = 0.3;

  musicManager.fadeFSTimeIn = 0.3;
  musicManager.fadeFSTimeOut = 0.3;

  musicManager.fadeBigWinTimeIn = 0.5;
  musicManager.fadeBigWinTimeOut = 0.5;

  musicManager.maxMusicVolume = 0.56;
  musicManager.midMusicVolume = 0.35;
  musicManager.loweredMusicVolume = 0.2;

  musicManager.baseMusic = ['gameTheme0', 'gameTheme1', 'gameTheme2', 'gameTheme3'];
  musicManager.basePlaying = musicManager.ALLOFFLEVEL;
  musicManager.baseID = [];
  musicManager.currentBaseLevel = -1;

  musicManager.freeSpinsMusic = ['freeSpinsLoop0', 'freeSpinsLoop1', 'freeSpinsLoop2'];
  musicManager.fsPlaying = musicManager.FREESPINS_ALLOFF;
  musicManager.freeSpinsID = [];
  musicManager.currentFSLevel = -1;

  musicManager.wheelSpinMusic = ['wheelTheme0'];
  musicManager.wheelSpinPlaying = musicManager.WHEELSPIN_ALLOFF;
  musicManager.wheelSpinID = [];

  // I'd go Royals > stake for lo, cake, cocktail, disco ball for med and dancing pig, logo for hi, assuming they are > stake
  const symbolsConfig = resourceManager.getConfiguration().symbols;
  const lowSounds = ['lowWin0', 'lowWin1', 'lowWin2'];
  const medSounds = ['medWin0', 'medWin1', 'medWin2'];
  const hiSounds = ['hiWin0', 'hiWin1', 'hiWin2'];
  musicManager.symbolIdToWinSoundMap = {
    [symbolsConfig['Ten'].ID]: lowSounds,
    [symbolsConfig['Jack'].ID]: lowSounds,
    [symbolsConfig['Queen'].ID]: lowSounds,
    [symbolsConfig['King'].ID]: lowSounds,
    [symbolsConfig['Ace'].ID]: lowSounds,
    [symbolsConfig['Hogtail'].ID]: medSounds,
    [symbolsConfig['Cake'].ID]: medSounds,
    [symbolsConfig['Disco'].ID]: 'discoBallWin',
    [symbolsConfig['Dancer'].ID]: hiSounds,
    [symbolsConfig['Logo'].ID]: hiSounds,
  };
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (let i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (let j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(soundManager.play(musicManager.freeSpinsMusic[j]));
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  // setup wheel spin music tracks - all volumes 0
  for (let k = 0; k < musicManager.wheelSpinMusic.length; k++) {
    musicManager.wheelSpinID.push(soundManager.play(musicManager.wheelSpinMusic[k]));
    soundManager.setVolume(0, musicManager.wheelSpinID[k]);
  }
};

musicManager.playSound = function (sounds) {
  let id = null;
  if (!Array.isArray(sounds)) {
    sounds = [sounds];
  }
  const randIndex = Math.floor(Math.random() * sounds.length);
  const sound = sounds[randIndex];
  id = soundManager.play(sound);
  console.log('musicManager.playSound', sounds, sound);

  return id;
};

musicManager.onSplashScreenComplete = function () {
  soundManager.play('piggies3');
  musicManager.changeBaseLevel(musicManager.IDLELEVEL, true);
  musicManager.currentMusicVolume = musicManager.maxMusicVolume;
};

musicManager.onGameStart = function () {
  musicManager.stopStepDownTimer();
  musicManager.idle = false;
  if (musicManager.basePlaying === musicManager.IDLELEVEL && !musicManager.inFreeSpins) {
    musicManager.changeBaseLevel(musicManager.SPINLEVEL);
  }
};

musicManager.stopStepDownTimer = function () {
  console.log('musicManager.stopStepDownTimer');
  timerManager.stop(musicManager.stepDownTimer);
};

musicManager.restartStepDownTimer = function () {
  console.log('musicManager.restartStepDownTimer');
  musicManager.stopStepDownTimer();
  console.log('musicManager.restartStepDownTimer - addTimer 6000');
  musicManager.stepDownTimer = timerManager.addTimer(6000, undefined, musicManager.stepDown);
};

musicManager.playBasegameSoundBasedOnWinnings = function (
  totalWinnings,
  timeIn = musicManager.fadeBaseTimeIn,
  timeOut = musicManager.fadeBaseTimeOut
) {
  const stake = resourceManager.getController('stakeController').CurrentStake;
  if (totalWinnings > 10 * stake) {
    musicManager.changeBaseLevel(musicManager.MORE_THAN_10X_LEVEL, true, timeIn, timeOut);
  } else if (totalWinnings > 2 * stake) {
    musicManager.changeBaseLevel(musicManager.MORE_THAN_2X_LEVEL, true, timeIn, timeOut);
  } else {
    musicManager.changeBaseLevel(musicManager.SPINLEVEL, true, timeIn, timeOut);
  }
};

musicManager.onGameEnd = function (bigWinLevel = -1) {
  console.log('musicManager.onGameEnd', bigWinLevel);
  musicManager.fadeWSLevels(musicManager.WHEELSPIN_ALLOFF, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  const justLeftBigWin = bigWinLevel >= 0;
  if (!musicManager.wasInFreeSpins) {
    console.log('musicManager.onGameEnd - NO FS');
    musicManager.idle = true;
    if (justLeftBigWin) {
      console.log('musicManager.onGameEnd - NO FS - we have had a big win');
      musicManager.playBasegameSoundBasedOnWinnings(gameController.totalWinnings);
    } else {
      console.log('musicManager.onGameEnd - NO FS - no big win');
      // musicManager.playBasegameSoundBasedOnWinnings(gameController.totalWinnings);
    }
  } else {
    // we have come from free spins
    if (justLeftBigWin) {
      console.log('musicManager.onGameEnd - FS - we have had a big win');
      musicManager.playBasegameSoundBasedOnWinnings(gameController.totalWinnings);
    } else {
      console.log('musicManager.onGameEnd - FS - no big win');
      // nothing to do
    }
    // dont think we need return music if we can all be done in here!!!
  }

  musicManager.wasInFreeSpins = false;
  musicManager.checkLossStreak(gameController.totalWinnings);
  musicManager.restartStepDownTimer();
};

musicManager.stepDown = function () {
  console.log('musicManager.stepDown');
  // code is to step back down to idle level
  if (
    musicManager.basePlaying === musicManager.MORE_THAN_10X_LEVEL ||
    musicManager.basePlaying === musicManager.MORE_THAN_2X_LEVEL ||
    musicManager.basePlaying === musicManager.SPINLEVEL
  ) {
    musicManager.stopStepDownTimer();
    musicManager.changeBaseLevel(musicManager.IDLELEVEL, true, 2.5, 3);
    musicManager.currentLossStreak = 0;
    console.log('musicManager.stepDown - IDLE');
  }

  // below code is for decreasing ONE level

  // if (musicManager.basePlaying === musicManager.MORE_THAN_10X_LEVEL) {
  //   musicManager.stepDownTimer = timerManager.addTimer(6000, undefined, musicManager.stepDown);
  //   musicManager.fadeLevels(musicManager.MORE_THAN_2X_LEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  //   musicManager.currentBaseLevel = 2;
  // } else if (musicManager.basePlaying === musicManager.MORE_THAN_2X_LEVEL) {
  //   musicManager.stepDownTimer = timerManager.addTimer(6000, undefined, musicManager.stepDown);
  //   musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  //   musicManager.currentBaseLevel = 1;
  // } else if (musicManager.basePlaying === musicManager.SPINLEVEL) {
  //   timerManager.stop(musicManager.stepDownTimer);
  //   musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  //   musicManager.currentBaseLevel = 0;
  // }
};

musicManager.playBigWin = function () {
  console.log('musicManager.playBigWin');
  musicManager.bigWinID = soundManager.play('bigWinLoop');

  musicManager.changeFSLevel(
    musicManager.FREESPINS_ALLOFF,
    musicManager.fadeBigWinTimeIn,
    musicManager.fadeBigWinTimeOut
  );
  musicManager.changeBaseLevel(
    musicManager.ALLOFFLEVEL,
    true,
    musicManager.fadeBigWinTimeIn,
    musicManager.fadeBigWinTimeOut
  );
};

musicManager.playBigWinUpgrade = function () {
  console.log('musicManager.playBigWinUpgrade');
  soundManager.play('bigWinUpgrade');
};

musicManager.playBigWinEnd = function () {
  if (!musicManager.isSoundPlaying('bigWinEnd')) {
    console.log('musicManager.playBigWinEnd');
    soundManager.stop('bigWinLoop');
    soundManager.play('bigWinEnd');
  } else {
    console.log('musicManager.playBigWinEnd - already playing');
  }
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime) {
  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeIn[i], undefined);
  }

  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOut[i], undefined);
  }

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];
  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
    }
  }
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeInFS[i], undefined);
  }
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutFS[i]);
  }
  musicManager.fsPlaying = levels;
};

musicManager.fadeWSLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutWS = [];
  musicManager.soundsToFadeInWS = [];
  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.wheelSpinPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInWS.push(musicManager.wheelSpinID[i]);
    } else if (levels[i] === false && musicManager.wheelSpinPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutWS.push(musicManager.wheelSpinID[i]);
    }
  }
  for (var i = 0; i < musicManager.soundsToFadeInWS.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeInWS[i], undefined);
  }
  for (var i = 0; i < musicManager.soundsToFadeOutWS.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutWS[i]);
  }
  musicManager.wheelSpinPlaying = levels;
};

musicManager.onFreespinsIntro = function (wheelBonus = false) {
  musicManager.changeBaseLevel(musicManager.ALLOFFLEVEL, true, 0, 0);
  musicManager.fadeWSLevels(musicManager.WHEELSPIN_ALLOFF, 0, 0);

  soundManager.play('freeSpinsIntro');
  musicManager.inFreeSpins = true;
  musicManager.fsIntroTimer = timerManager.addTimeout(3000, () => {
    if (wheelBonus === true) {
      musicManager.playWheelTune();
    } else {
      musicManager.onFreeSpinsStart();
    }
  });
};

musicManager.onFreeSpinsStart = function () {
  if (musicManager.isSoundPlaying('freeSpinsIntro')) {
    soundManager.stop('freeSpinsIntro');
  }
  musicManager.changeFSLevel(musicManager.FREESPINS_BASE, 2.5, 2.5);
};

musicManager.onFreespinsOutro = function () {
  musicManager.inFreeSpins = false;
  musicManager.wasInFreeSpins = true;
  musicManager.changeFSLevel(musicManager.FREESPINS_ALLOFF, musicManager.fadeBaseTimeIn, 0);
  soundManager.play('freeSpinsOutro');
  musicManager.fsOutroTimer = timerManager.addTimeout(2500, () => {
    musicManager.onFreeSpinsEnd();
  });
};

musicManager.onFreeSpinsEnd = function () {
  if (musicManager.isSoundPlaying('freeSpinsOutro')) {
    soundManager.stop('freeSpinsOutro');
  }

  musicManager.playBasegameSoundBasedOnWinnings(gameController.totalWinnings);

  musicManager.currentLossStreak = 0;
};

musicManager.playWinForSymbol = function (symbolId) {
  const bestSymbolWinSound = musicManager.symbolIdToWinSoundMap[symbolId];
  if (bestSymbolWinSound) {
    console.log('musicManager.playWinForSymbol', symbolId);
    musicManager.playSound(bestSymbolWinSound);
  }
};

musicManager.playSpinButtonSound = function () {
  musicManager.stopSpinButtonSound();
  musicManager.currentSpinButtonSound = musicManager.playSound(musicManager.spinButtonSounds);
  console.log('musicManager.playSpinButtonSound', musicManager.currentSpinButtonSound);
};

musicManager.stopSpinButtonSound = function () {
  if (typeof musicManager.currentSpinButtonSound !== 'undefined') {
    console.log('musicManager.stopSpinButtonSound', musicManager.currentSpinButtonSound);
    soundManager.stop(musicManager.currentSpinButtonSound);
    musicManager.currentSpinButtonSound = undefined;
  }
};

musicManager.playWheelTune = function () {
  console.log('musicManager.playWheelTune');
  if (musicManager.isSoundPlaying('freeSpinsIntro')) {
    soundManager.stop('freeSpinsIntro');
  }
  musicManager.changeBaseLevel(musicManager.ALLOFFLEVEL, true);
  musicManager.fadeWSLevels(musicManager.WHEELSPIN_BASE, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  musicManager.currentLossStreak -= 1;
};

musicManager.stopWheelTune = function (goingToFeature) {
  console.log('musicManager.stopWheelTune');

  if (!goingToFeature) {
    musicManager.inFreeSpins = false;
    musicManager.playBasegameSoundBasedOnWinnings(gameController.totalWinnings, 2, 2);
  }
  musicManager.fadeWSLevels(musicManager.WHEELSPIN_ALLOFF, 2, 2);
};

// is there a better what to handle this?
musicManager.convertBaseArrayLevelToIndex = function (level) {
  let result = level;
  if (Array.isArray(level) === true) {
    if (level === musicManager.ALLOFFLEVEL) {
      result = -1;
    } else if (level === musicManager.IDLELEVEL) {
      result = 0;
    } else if (level === musicManager.SPINLEVEL) {
      result = 1;
    } else if (level === musicManager.MORE_THAN_2X_LEVEL) {
      result = 2;
    } else if (level === musicManager.MORE_THAN_10X_LEVEL) {
      result = 3;
    } else {
      result = undefined;
    }
  } else {
    // not an array
  }
  return result;
};

musicManager.changeBaseLevel = function (
  level,
  force = false,
  timeIn = musicManager.fadeBaseTimeIn,
  timeOut = musicManager.fadeBaseTimeOut
) {
  level = musicManager.convertBaseArrayLevelToIndex(level);

  if (musicManager.currentBaseLevel < level || force) {
    console.log('musicManager.changeBaseLevel - new level', level);
    musicManager.currentBaseLevel = level;
    let newLevel = null;
    switch (level) {
      case -1:
        newLevel = musicManager.ALLOFFLEVEL;
        break;
      case 0:
        newLevel = musicManager.IDLELEVEL;
        break;
      case 1:
        newLevel = musicManager.SPINLEVEL;
        break;
      case 2:
        newLevel = musicManager.MORE_THAN_2X_LEVEL;
        break;
      case 3:
        newLevel = musicManager.MORE_THAN_10X_LEVEL;
        break;
      default:
        break;
    }
    if (newLevel != null) {
      musicManager.fadeLevels(newLevel, timeIn, timeOut);
    } else {
      console.log('musicManager.changeBaseLevel - invalid level passed', musicManager.currentBaseLevel, level);
    }
  } else {
    console.log('musicManager.changeBaseLevel - nothing to change', musicManager.currentBaseLevel, level);
  }
};

// is there a better what to handle this?
musicManager.convertFSArrayLevelToIndex = function (level) {
  let result = level;
  if (Array.isArray(level) === true) {
    if (level === musicManager.FREESPINS_ALLOFF) {
      result = -1;
    } else if (level === musicManager.FREESPINS_BASE) {
      result = 0;
    } else if (level === musicManager.FREESPINS_LEVEL1) {
      result = 1;
    } else if (level === musicManager.FREESPINS_LEVEL2) {
      result = 2;
    } else {
      result = undefined;
    }
  } else {
    // not an array
  }
  return result;
};

musicManager.changeFSLevel = function (
  level,
  timeIn = musicManager.fadeFSTimeIn,
  timeOut = musicManager.fadeFSTimeOut
) {
  level = musicManager.convertFSArrayLevelToIndex(level);

  if (musicManager.currentFSLevel !== level) {
    console.log('musicManager.changeFSLevel - new level', level);
    musicManager.currentFSLevel = level;
    let newLevel = null;
    switch (level) {
      case -1:
        newLevel = musicManager.FREESPINS_ALLOFF;
        break;
      case 0:
        newLevel = musicManager.FREESPINS_BASE;
        break;
      case 1:
        newLevel = musicManager.FREESPINS_LEVEL1;
        break;
      case 2:
        newLevel = musicManager.FREESPINS_LEVEL2;
        break;
      default:
        break;
    }
    if (newLevel != null) {
      musicManager.fadeFSLevels(newLevel, timeIn, timeOut);
    } else {
      console.log('musicManager.changeFSLevel - invalid level passed', musicManager.currentFSLevel, level);
    }
  } else {
    console.log('musicManager.changeFSLevel - nothing to change', musicManager.currentFSLevel, level);
  }
};

musicManager.checkLossStreak = function (winnings) {
  console.log('musicManager.checkLossStreak', winnings);
  const stake = resourceManager.getController('stakeController').CurrentStake;
  let resetStreak = false;
  if (winnings > 10 * stake) {
    resetStreak = true;
  } else if (winnings > 2 * stake && musicManager.basePlaying === musicManager.MORE_THAN_2X_LEVEL) {
    resetStreak = true;
  } else {
    // any other win should increment loss streak
  }

  if (resetStreak === true) {
    console.log('musicManager.checkLossStreak - reset');
    musicManager.currentLossStreak = 0;
  } else {
    musicManager.currentLossStreak++;
    console.log('musicManager.checkLossStreak - increment', musicManager.currentLossStreak);
    if (musicManager.currentLossStreak >= 5) {
      console.log('musicManager.checkLossStreak : musicManager.currentLossStreak >= 5');
      musicManager.currentLossStreak = 0;
      if (musicManager.currentBaseLevel > 1) {
        console.log('musicManager.checkLossStreak : changeBaseLevel');
        musicManager.changeBaseLevel(--musicManager.currentBaseLevel, true);
      }
    }
  }
};

musicManager.handleBasegameSoundLevel = function (win) {
  const stake = resourceManager.getController('stakeController').CurrentStake;

  // gameController.spinHasWin
  if (win > 10 * stake) {
    console.log('musicManager.handleBasegameSoundLevel : musicManager.changeBaseLevel(3)');
    musicManager.changeBaseLevel(musicManager.MORE_THAN_10X_LEVEL);
  } else if (win > 2 * stake) {
    console.log('musicManager.handleBasegameSoundLevel : musicManager.changeBaseLevel(2)');
    musicManager.changeBaseLevel(musicManager.MORE_THAN_2X_LEVEL);
  }
};

musicManager.handleFreeSpinsSoundLevel = function (accumulatedWin) {
  console.log('musicManager.handleFreeSpinsSoundLevel');
  const stake = gameController.globalHelperGetStake();
  const thresholds = gameController.inBuyABonus ? [1.25, 1.5] : [20, 50];
  if (accumulatedWin > thresholds[1] * stake) {
    musicManager.changeFSLevel(musicManager.FREESPINS_LEVEL2);
  } else if (accumulatedWin > thresholds[0] * stake) {
    musicManager.changeFSLevel(musicManager.FREESPINS_LEVEL1);
  }
};

// now all done via onGameEnd
// why have multiple functions at the end of a game?
// musicManager.returnMusic = function () {
//   console.log('musicManager.returnMusic');
//   if (musicManager.inFreeSpins) {
//     if (musicManager.fsPlaying === musicManager.FREESPINS_ALLOFF) {
//       musicManager.fadeFSLevels(
//         musicManager.FREESPINS_BASE,
//         musicManager.fadeBigWinTimeIn,
//         musicManager.fadeBigWinTimeOut
//       );
//     }
//   } else if (musicManager.basePlaying === musicManager.ALLOFFLEVEL) {
//     // this this is wrong
//     // think we should dtop to
//     musicManager.currentBaseLevel = 0;
//     musicManager.handleBasegameSoundLevel(gameController.totalWinnings);
//   }
// };

musicManager.changeMusicVolume = function (newVolume) {
  if (musicManager.currentMusicVolume !== newVolume) {
    musicManager.currentMusicVolume = newVolume;

    const musicPlaying = musicManager.inFreeSpins ? musicManager.fsPlaying : musicManager.basePlaying;
    const musicIds = musicManager.inFreeSpins ? musicManager.freeSpinsID : musicManager.baseID;
    musicPlaying.forEach((music, index) => {
      if (music) soundManager.fade(newVolume, 0.3, musicIds[index]);
    });
  }
};

musicManager.isSoundPlaying = function (tag) {
  if (soundManager.soundsConfig.tags[tag] != null) {
    return soundManager.isSoundPlaying(soundManager.soundsConfig.tags[tag].filename);
  }
  return false;
};

musicManager.playCoinFrenzySFX = function () {
  soundManager.play('coinFrenzy');
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === 'back from replay' && !Reflex.replayGame) {
    musicManager.basePlaying = musicManager.ALLOFFLEVEL;
    musicManager.baseID = [];
    musicManager.fsPlaying = musicManager.FREESPINS_ALLOFF;
    musicManager.freeSpinsID = [];
    musicManager.wheelSpinID = [];
    musicManager.wheelSpinPlaying = musicManager.WHEELSPIN_ALLOFF;
    musicManager.onGameLoaded();
    musicManager.currentFSLevel = -1;
    musicManager.currentBaseLevel = -1;
    musicManager.changeBaseLevel(musicManager.IDLELEVEL, true);
  }
};

messageBus.subscribe('sounds:restorePreviouslyPlayingAudio', musicManager.onRestorePreviouslyPlayingAudio);

Reflex.registerInitialiseManager(musicManager.initialise);
